import { ChangeEvent } from 'react';
import { Card, Checkbox } from '@mui/material';
import { NetworkIcon } from 'elements/NetworkIcon';
import { Masonry } from 'components/Masonry';
import { PostListSkeleton } from 'components/PostListSkeleton';
import { PostToImport } from 'lib/types/posts';
import { PostContent } from './PostContent';

interface Props {
  posts: PostToImport[];
  selectedPostIds: string[];
  onSelectPost: (sourceId: string) => void;
  onRemovePost: (sourceId: string) => void;
}

export const PostList = ({
  posts, selectedPostIds, onSelectPost, onRemovePost,
}: Props) => {
  const isPostSelected = (postId: string) => selectedPostIds.includes(postId);

  const onSelect = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      onSelectPost(e.target.value);
    } else {
      onRemovePost(e.target.value);
    }
  };

  return (
    <>
      {!posts ? (<PostListSkeleton />) : (
        <>
          <Masonry>
            {posts.map((post: any) => {
              const isSelected = isPostSelected(post.sourceId);

              return (
                <div className="py-3" key={post.sourceId}>
                  <Card
                    elevation={2}
                    className={`${isSelected && 'border-2 border-orange'}`}
                  >
                    <div className="p-2 flex justify-between items-center">
                      <div className="flex w-1/2">
                        <NetworkIcon fontSize="medium" network={post.network} iconColor="monochrome" />
                        <div className="pl-1 text-left font-bold whitespace-nowrap overflow-ellipsis">
                          @
                          {post.account}
                        </div>
                      </div>
                      <div className="z-50 bg-white dark:bg-appbg-dark">
                        <Checkbox
                          checked={isSelected}
                          onChange={onSelect}
                          value={post.sourceId}
                        />
                      </div>
                    </div>
                    <div>
                      <PostContent post={post} />
                    </div>
                  </Card>
                </div>
              );
            })}
          </Masonry>
        </>
      )}
    </>
  );
};
